export const rootURL = "https://api.mp.kangfutang.vip";
export const baseURL = rootURL + "/api";
export const appid='wx3700593766d87e45';

// 聊天服务独立域名（部署后修改为实际域名）
export const chatApiUrl = "https://api.chat.kangfutang.vip";
export const chatBaseURL = chatApiUrl + "/api";
export const chatWsUrl = chatApiUrl.replace("https://", "wss://").replace("http://", "ws://") + "/ws/chat";

// AI智能客服服务域名（部署后修改为实际域名）
export const aiApiUrl = "https://ai.kangfutang.vip";
export const aiBaseURL = aiApiUrl + "/api";
